import React from 'react';
import { useTranslation } from 'react-i18next';
import './StartChat.scss';
import { TextButton } from '@shape-ds/components';
import {
  ContentPasteSearchOutlined,
  FormatListNumberedOutlined,
  PlaylistAddOutlined,
} from '@mui/icons-material';
interface StartChatProps {
  onClick: (message: string) => void;
}
const SuggestionsIconMap = {
  cases: <FormatListNumberedOutlined />,
  new_case: <PlaylistAddOutlined />,
  asset: <ContentPasteSearchOutlined />,
};

const StartChat: React.FC<StartChatProps> = ({ onClick }) => {
  const { t } = useTranslation();
  const suggestions = t('chat:chat_suggestions', { returnObjects: true });

  return (
    <div className="start-chat">
      <h2 className="start-chat-title">{t('chat:help_title')}</h2>
      <div className="start-chat-wrapper">
        {Object.keys(suggestions).map((key) => {
          return (
            <TextButton
              onClick={() => onClick(t(`chat:chat_suggestions.${key}`))}
              startIcon={SuggestionsIconMap[key as keyof typeof SuggestionsIconMap]}
              key={key}
            >
              {t(`chat:chat_suggestions.${key}`)}
            </TextButton>
          );
        })}
      </div>
    </div>
  );
};

export default StartChat;
